/* eslint-disable */
import session from './session';

export default {
  getStatistic() {
    return session.get(`/api/v1/statistic/`);
  },
};
